<!-- Layout correspondiente a la parte privada. Todas las rutas que lo usen asumen mínimo que el usuario está autenticado -->
<template>
  <div id="private-layout">
    <nav class="navbar navbar-expand-lg sticky-top">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          <img src="@assets/images/logotipo-oscilion.svg" />
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon "></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav nav-primary">
            <li v-if="tienePermisoPortalVisorOscilos(autho)" class="nav-item">
              <I18NRouteLink :to="{ name: 'oscilos-view' }" class="nav-link">
                <i class="fa-regular fa-signal-alt" :title="$t('menu.items.visor_oscilos')"></i>
                {{ $t('menu.items.visor_oscilos') }}
              </I18NRouteLink>
            </li>
            <li v-if="tienePermisoPortalWikiSucesos(autho)" class="nav-item">
              <I18NRouteLink :to="{ name: 'wiki-view' }" class="nav-link">
                <i class="fa-regular fa-folder-tree" :title="$t('menu.items.wiki')"></i>
                {{ $t('menu.items.wiki') }}
              </I18NRouteLink>
            </li>
            <li v-if="tienePermisoPortalAdministracion(autho)" class="nav-item">
              <I18NRouteLink :to="{ name: 'oscilos-administracion-view' }" class="nav-link">
                <i class="fa-regular fa-gear" :title="$t('menu.items.administracion')"></i>
                {{ $t('menu.items.administracion') }}
              </I18NRouteLink>
            </li>
          </ul>

          <div class="d-flex gap-2">
            <DxButton @click="abrirOsciloExe" stylingMode="outlined" icon="fa-solid fa-external-link">{{
              $t("menu.items.abrir_oscilos")
            }}</DxButton>

            <DxButton @click="abrirSigraExe" stylingMode="outlined" icon="fa-solid fa-external-link">{{
              $t("menu.items.abrir_seagram")
            }}</DxButton>

            <DxButton @click="showHelpModal = true" stylingMode="outlined">
              <i class="fa-regular fa-circle-question"></i>
              {{ $t("menu.items.help") }}
            </DxButton>

            <div class="align-content-center ">
              {{ auth.userInfo?.username }}
            </div>

            <DxButton @click="logout" stylingMode="outlined">{{
              $t("shared.ui.buttons.logout")
            }}</DxButton>
          </div>
        </div>
      </div>
    </nav>

    <main>
      <slot></slot>
    </main>

  </div>
  <footer v-if="showFooter">© UNATEC ICT SL | Todos los derechos reservados</footer>

  <HelpView v-model:visible="showHelpModal" />
</template>

<script setup lang="ts">
import { useAuthentication } from "@services/auth";
import { DxButton } from "devextreme-vue";
import I18NRouteLink from "@components/i18n/I18NRouteLink.vue";
import { useApi } from "@/.shared/.api/integration";
import { onMounted, ref } from "vue";
import { tienePermisoPortalAdministracion, tienePermisoPortalVisorOscilos, tienePermisoPortalWikiSucesos } from "@/.shared/helpers/permission-helper";
import { useAuthorization } from "@/.shared/services/auth/authorization";
import HelpView from "@/components/help/HelpView.vue";

const auth = useAuthentication();
const autho = useAuthorization();
const showHelpModal = ref(false);

function logout() {
  auth.logout(import.meta.env.VITE_BASE_URL);
}

const showFooter = ref(true);

function toggleFooter() {
  showFooter.value = !showFooter.value;
}

onMounted(async () => {
});

function abrirOsciloExe(): void {
  window.open('oscilo://', '_blank');
}

function abrirSigraExe(): void {
  window.open('digsi4://', '_blank');
}

</script>

<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

.navbar {
  padding: 4px 0px;
  background: var(--background-default-default);
  /* Shadow-components */
  box-shadow: 0px 4px 4px 0px rgba(36, 36, 36, 0.10);
  align-items: center;

  img {
    height: 53px;
  }

}

.navbar-brand {
  padding: 0;
}

.nav-primary {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;


  .nav-link {
    display: flex;
    padding: var(--button-vertical-padding) var(--button-horizontal-padding);
    gap: 12px;
    border-radius: var(--button-radius);
    transition: all .2s ease-in;
    align-items: center;

    i {
      color: var(--icon-secondary-default);
    }

    &:hover {
      background: var(--background-primary-alt-hover);
      color: var(--text-primary-default);
    }

    &.router-link-active {
      background: var(--background-secondary-default);
      color: var(--text-secondary-on-action);

      i {
        color: var(--text-secondary-on-action);
      }

    }
  }
}

.dx-button-mode-outlined.dx-state-hover {
  color: $base-accent;
}

footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: var(--background-secondary-default);
  color: var(--text-secondary-on-action);
  min-height: var(--spacing-sm);
  padding: var(--spacing-2xs) var(--spacing-md) 0;
  text-align: center;
  font-size: var(--font-size-body-sm);
  z-index: 999;
}

@media (max-width: 991px) {
  .nav-primary {
    align-items: start;

  }
}
</style>
